// TODO: Most of these constants should be replaced with use of enums or classes, please don't add new constants
export enum AConst {
  ANSWER = 'answer',
  ARRAY = 'array',
  ARRAY_LEVEL = 'array_level',
  ARTIFACT = 'artifact',
  ARTIFACT_ID = 'artifact_id',
  ARTIFACT_NAME = 'artifact_name',
  ATTACHMENT_TYPE = 'attachment_type',
  CATEGORIES = 'categories',
  CATEGORY_TITLE = 'category_title',
  CONTENT_MENU_OBJECT_SOURCE_LIST = 'content_menu_object_source_list',
  CONTENT_MENU_SEARCH_VIEW = 'content_menu_search_view',
  CONTENT_LIST = 'content_list',
  CONTEXT_OBJECT_TYPE = 'context_object_type',
  CREATED_BY_ID = 'created_by_id',
  EDIT = 'edit',
  EDIT_ONCE = 'edit_once',
  EDIT_ONCE_NOT_STORED = 'edit_once_not_stored',
  EDIT_OWNER = 'edit_owner',
  F_PATH = 'f_path',
  FAQ = 'faq',
  FIELD_ATTACHMENT_ID = 'attachment_id',
  FIELD_AUDIO_ID = 'audio_id',
  FIELD_GROUP_NAME = 'group_name',
  FIELD_IMAGE_ID = 'image_id',
  FIELD_MODEL_3D_ID = 'model_3d_id',
  FIELD_TEMPLATE_GROUP_ID = 'template_group_id',
  FIELD_TEMPLATE_GROUPS = 'template_groups',
  FIELD_TEMPLATE_MODELS = 'template_models',
  FIELD_VIDEO_ID = 'video_id',
  FIELD_UUID = 'field_uuid',
  ICON_FRAME = 'icon_frame',
  INLINE_ATTRIBUTE_MODEL = 'model',
  MAP_ID = 'map_id',
  MESSAGE = 'message',
  MESSAGES = 'messages',
  META_TYPE = 'meta_type',
  META_TYPE_MODEL = 'model',
  META_TYPE_TEMPLATE_MODEL = 'template_model',
  MAX_FILTER_LENGTH = 10,
  NAME = 'name',
  OBJECT_TYPE = 'object_type',
  OBJECT_TYPE_AGENT = 'agent',
  OBJECT_TYPE_AGENT_ABSTRACT = 'AgentAbstract',
  OBJECT_TYPE_ATTACHMENT_ITEM = 'AttachmentItem',
  OBJECT_TYPE_AUDIO_ITEM = 'AudioItem',
  OBJECT_TYPE_COLLECTION = 'Collection',
  OBJECT_TYPE_IMAGE_ITEM = 'ImageItem',
  OBJECT_TYPE_MODEL_3D_ITEM = 'Model3DItem',
  OBJECT_TYPE_NAMED_OBJECT = 'named_object',
  OBJECT_TYPE_TEMPLATE_GROUP_ITEM = 'TemplateGroupItem',
  OBJECT_TYPE_TEMPLATE_GROUPS = 'TemplateGroups',
  OBJECT_TYPE_TEMPLATE_GROUP_SELECTOR = 'TemplateGroupSelector',
  OBJECT_TYPE_TEMPLATE_MODEL = 'TemplateModel',
  OBJECT_TYPE_TEMPLATE_MODEL_OVERVIEW_FIELDS_FOR_FIELD_SELECT = 'TemplateModelOverviewFieldsForFieldSelect',
  OBJECT_TYPE_TEMPLATE_MODELS = 'TemplateModels',
  OBJECT_TYPE_VIDEO_ITEM = 'VideoItem',
  ORDER = 'order',
  ORDER_NUMBER = 'order_number',
  OVERVIEW_FIELDS = 'overview_fields',
  PARENT_FIELD = 'parent_field',
  PARENT_ID = 'parent_id',
  PARENT_NAME = 'parent_name',
  QUERY_FIELD = 'query_field',
  REG_LEVEL = 'reg_level',
  REG_LEVEL_TYPE_ID = 'reg_level_type_id',
  SOURCE_FIELD = 'source_field',
  STATUS_MSG = 'status_msg',
  SUB_MENUS = 'sub_menus',
  THING = 'thing',
  USAGE = 'usage',
  USER = 'user',
  WHAT_IS_NEW = 'what_is_new'
}
